export const ZEBRA_ERROR_CUTTER_FAULT = "E_1_8";
export const ZEBRA_ERROR_HEAD_OPEN = "E_1_4";
export const ZEBRA_ERROR_RIBBON_OUT = "E_1_2";
export const ZEBRA_ERROR_MEDIA_OUT = "E_1_1";

export const ZEBRA_WARNING_AT_SENSOR_PRESENTER = "W_3_1";
export const ZEBRA_WARNING_AT_SENSOR_RETRACT_READY = "W_3_2";
export const ZEBRA_WARNING_AT_SENSOR_IN_RETRACT = "W_3_4";
export const ZEBRA_WARNING_AT_SENSOR_AT_BIN = "W_3_8";
export const ZEBRA_WARNING_PAPER_LOW = "W_1_8";



// WEBPACK FOOTER //
// ./src/HOCs/Constants/ZebraErrorCodes.js